import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentReasonTypeDatasource } from '../datasources/appointment_reason_type_datasource';
import { IAppointmentType, ICourse, IStudentService, IStudentServiceCategory } from '../types/appointment_interfaces';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IAppointmentsServiceQuery {
  servicesList: IStudentService[];
  serviceInstructions: string;
  hasServices: boolean;
  errorMessage: string;
}

export class AppointmentsServiceQuery implements IQuery {
  private _result: IAppointmentsServiceQuery;

  constructor(
    private ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {
    ORMMediator.registerQuery(this, ngAppointmentReasonTypeDatasource, ngAppointmentReasonUsersource);
  }

  studentServicesData(servicesList: IStudentService[]) {
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    const hasServices = servicesList.length > 0;
    const serviceInstructions = selectedType.instructions.student_service;
    const errorMessage =
      selectedType.instructions.reason_error ||
      `${
        this.ngAppointmentReasonUsersource.read().selectedCategory.name ||
        this.ngAppointmentReasonUsersource.read().selectedType.name
      } is not available`;
    return { hasServices, serviceInstructions, errorMessage };
  }

  coursesList(courses: ICourse[]) {
    return _4.map(courses, (course: ICourse) => ({
      id: course.id,
      name: `${course.name} (course)`,
      isCourse: true,
      deny_students_to_choose_organizer: false
    }));
  }

  run(): this {
    let serviceInstructions: string = '';
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    const selectedCategory: IStudentServiceCategory = this.ngAppointmentReasonUsersource.read().selectedCategory;
    let servicesList: IStudentService[] = [];
    let errorMessage: string = '';
    let hasServices: boolean = false;

    if (selectedCategory.id) {
      const courses = selectedCategory.include_courses ? selectedCategory.courses : [];
      servicesList = [...selectedCategory.student_services, ...this.coursesList(courses)];
      ({ hasServices, serviceInstructions, errorMessage } = this.studentServicesData(servicesList));
    } else if (_4.isNull(selectedType.student_service_categories)) {
      const courses = selectedType.include_courses ? selectedType.courses : [];
      const studentServices = selectedType.student_services || [];
      servicesList = [...studentServices, ...this.coursesList(courses)];
      ({ hasServices, serviceInstructions, errorMessage } = this.studentServicesData(servicesList));
    }
    this._result = {
      servicesList,
      serviceInstructions,
      hasServices,
      errorMessage
    };

    return this;
  }

  get result(): IAppointmentsServiceQuery {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_service_query.ts